import * as actionTypes from "../actionTypes/actionTypes";
import {
  createNewModelService,
  getModelsService,
  deleteModelService,
  createRepTextService,
  deleteRepTextService,
  saveRepTextService,
  getRegionsService,
  saveModelService
} from "../services/ModelsService";


const setShowPanel = (requestPayload) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.SET_SHOW_SIDE_PANEL,
      payload: requestPayload
    })
  }
}

const setModelSelectedPage = (requestPayload) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.SELECTED_MODEL_PAGE,
      payload: requestPayload
    })
  }
}

const getModels = () => {
    return async(dispatch) => {
        dispatch({
            type: actionTypes.GET_MODELS
        })
        window.startLoading();
        getModelsService()
        .then((response)=>{
          const data = response.data;
            dispatch({
                type: actionTypes.GET_MODELS_SUCCESS,
                payload: data
            })
        })
        .catch((error)=>{
          dispatch({
            type: actionTypes.DELETE_MODEL_FAILURE,
            payload: error
        })
        }).finally(()=>{
          window.stopLoading();
        })
    }
}

const deleteModel = (requestPayload) => {
  return async(dispatch) => {
      dispatch({
          type: actionTypes.DELETE_MODEL
      })
      window.startLoading();
      await deleteModelService(requestPayload)
      .then((response) => {
          const data = response.status;
          dispatch({
              type: actionTypes.DELETE_MODEL_SUCCESS,
              payload: data
          })
      })
      .catch((error) => {
          dispatch({
              type: actionTypes.DELETE_MODEL_FAILURE,
              payload: error
          })
      }).finally(()=>{
        window.stopLoading();
      })
  }
}

const createNewModel = (requestPayload) => {
  return async(dispatch) => {
    dispatch({
      type: actionTypes.CREATE_NEW_MODEL,
    });
    await createNewModelService(requestPayload)
      .then((response) => {
        const data = response.data;
        dispatch({
          type: actionTypes.CREATE_NEW_MODEL_SUCCESS,
          payload: data,
        });
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.CREATE_NEW_MODEL_FAILURE,
          payload: error,
        });
      });
  };
};

const updateModel = (requestPayload) => {
  return async(dispatch) => {
    dispatch({
      type: actionTypes.UPDATE_MODEL,
    });
    await saveModelService(requestPayload)
      .then((response) => {
        const data = response.status;
        dispatch({
          type: actionTypes.UPDATE_MODEL_SUCCESS,
          payload: data,
        });
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.UPDATE_MODEL_FAILURE,
          payload: error,
        });
      });
  };
};

const deleteRepText = (requestPayload) => {
  return async(dispatch) => {
      dispatch({
          type: actionTypes.DELETE_REPTEXT
      })
      await deleteRepTextService(requestPayload)
      .then((response) => {
          const data = response.status;
          dispatch({
              type: actionTypes.DELETE_REPTEXT_SUCCESS,
              payload: data
          })
      })
      .catch((error) => {
          dispatch({
              type: actionTypes.DELETE_REPTEXT_FAILURE,
              payload: error
          })
      })
  }
}

const createRepText = (requestPayload) => {
  return async(dispatch) => {
    dispatch({
      type: actionTypes.CREATE_NEW_REPTEXT,
    });
    await createRepTextService(requestPayload)
      .then((response) => {
        const data = response.status;
        dispatch({
          type: actionTypes.CREATE_NEW_REPTEXT_SUCCESS,
          payload: data,
        });
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.CREATE_NEW_REPTEXT_FAILURE,
          payload: error,
        });
      });
  };
};

const updateRepText = (requestPayload) => {
  return async(dispatch) => {
    dispatch({
      type: actionTypes.UPDATE_REPTEXT,
    });
    await saveRepTextService(requestPayload)
      .then((response) => {
        const data = response.status;
        dispatch({
          type: actionTypes.UPDATE_REPTEXT_SUCCESS,
          payload: data,
        });
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.UPDATE_REPTEXT_FAILURE,
          payload: error,
        });
      });
  };
};

const getRegions = () => {
  return async(dispatch) => {
      dispatch({
          type: actionTypes.GET_REGIONS
      })
      await getRegionsService()
      .then((response) => {
          const data = response.data;
          dispatch({
              type: actionTypes.GET_REGIONS_SUCCESS,
              payload: data
          })
      })
      .catch((error) => {
          dispatch({
              type: actionTypes.GET_REGIONS_FAILURE,
              payload: error
          })
      })
  }
}

export { setShowPanel, getModels, deleteModel, createNewModel, updateModel, deleteRepText, createRepText, updateRepText, getRegions, setModelSelectedPage };
